import { IEmptyResult } from '../types/IResponse';
import { IIdItem } from '../types/resourceParts';
import { Request } from './Request';

export interface ISetDatasourceUsingRemoteQueryAgentParams extends IIdItem {
  // There is no other param needed. The server will determine
  //  the value for the using_remote_query_agent column for the datasource in DB
  //  and set it if it needs to be true.
}

export class SetDatasourceUsingRemoteQueryAgentRequest extends Request<ISetDatasourceUsingRemoteQueryAgentParams,
    IEmptyResult> {
  constructor(params: ISetDatasourceUsingRemoteQueryAgentParams) {
    super('setDatasourceUsingRemoteQueryAgent', params);
  }
}
